
import IndexModel from "@/service/v1/sigap/IndexModel";

class QuadroHorarioService extends IndexModel {

    constructor() {
        super();
        this.url = this.url + '/QuadroHorario';
    }

    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }

    public getModel(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(this.url + '/' + id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // A3 — horas-aula disponíveis dado um quadro (+ opcionalmente conjunto de dias)
    public getHorasAula(id, params = ''): Promise<any> {
        const query = params ? ('?' + params) : '';
        return new Promise((resolve, reject) => {
            this.getAxios().get(this.url + '/' + id + '/HorasAula' + query)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }
 
    // ── Duplicar dia ─────────────────────────────────────────────────────────

    public duplicarDia(id: any, dados: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().post(`${this.url}/${id}/DuplicarDia`, dados)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // Duplica o quadro de horário inteiro (cabeçalho + itens) para a mesma turma.
    public duplicar(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().post(`${this.url}/${id}/Duplicar`, {})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

}

export default QuadroHorarioService;
